import React from 'react';

const RejectCircleIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="11" fill="#F04438" />
    <path
      d="M14.3346 7.66406L7.66797 14.3307M7.66797 7.66406L14.3346 14.3307"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RejectCircleIcon;
